import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=792d34be&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=js&"
export * from "./RoleList.vue?vue&type=script&lang=js&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=792d34be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d34be",
  null
  
)

export default component.exports